<div class="contentContainer">

    <!------------------------------------------------------------------------------ header -->

    <div fxLayout="row" fxLayoutAlign="space-between center" class="headerContentContainer">
        <div fxLayout="row">
            <div fxLayoutAlign="center center" class="grayLink" (click)="routeService.goBack()">
                <mat-icon class="linkIcon ft22">arrow_back</mat-icon>
            </div>
            <div>
                <h6 *ngIf="id" class="mgl10 ft500 ft16 mgb0 gray-9"> Ventas {{instructorNombre}}</h6>
                <h6 *ngIf="id===null" class="mgl10 ft500 ft16 mgb0 gray-9"> Ventas</h6>
            </div>
        </div>
        <div fxLayout="row">
            <div *ngIf="id && lenTransaccionesMarcadas>=1" (click)="openRegistrarPago()"
                class="sqChip ft12 ft500 backBlue5 shadow20">Registrar Prepago</div>
            <div *ngIf="id" routerLink="/admin/pagos/{{id}}" class="mgl10 sqChip ft12 ft500 backGray9 shadow20">
                Historial de pagos</div>
        </div>
    </div>

    <!----------------------------------------------------------------------------- Tabla  -->

    <div class="tableContainer">

        <table>
            <!-- Table header -->
                <tr class="tableHeaderContainer">
                    <th colspan="4" scope="colgroup" class=" border-r">Usuario</th>
                    <th colspan="5" scope="colgroup" class="border-r">Curso</th>
                    <th colspan="8" scope="colgroup" class="border-r">Transaccion</th>
                    <th *ngIf="id===null" colspan="8" scope="colgroup" class="border-r">Instructor</th>
                    <th *ngIf="id" colspan="9" scope="colgroup" class="border-r">Instructor</th>
                </tr>
                <tr class="tableHeaderContainer2">
                    <th class="">Id</th>
                    <th>Email</th>
                    <th>Nombre</th>
                    <th class="border-r">Tipo</th>
                    <th>Id</th>
                    <th>Titulo</th>
                    <th>$PO</th>
                    <th>% Desc</th>
                    <th class="border-r">$PF</th>
                    <th>Mon</th>
                    <th>Tax</th>
                    <th>Comison</th>
                    <th>Fecha</th>
                    <th>Estatus</th>
                    <th>Via Cobro</th>
                    <th>Fact</th>
                    <th class="border-r">Id</th>
                    <th>Id</th>
                    <th>Nombre</th>
                    <th>%</th>
                    <th>Total</th>
                    <th>Estatus Pago</th>
                    <th>Fecha Pago</th>
                    <th>Via Pago</th>
                    <th>Pago Id</th>
                    <th *ngIf="id">Acción</th>
                </tr>

            <!-- Table Data -->
            <tr *ngFor="let item of ventas;  let i=index" (click)="ind=i; openDetalleTransaccion(ind)">

                <td class="centertext ft10 ">{{item.usuarioId}}</td>
                <td class="centertext ft10 ">{{item.usuarioEmail}}</td>
                <td class="centertext ft10 ">{{item.usuarioNombre}}</td>
                <td class="centertext ft10 border-r">{{item.usuarioTipo}}</td>
                <td class="centertext ft10 ">{{item.cursoId}}</td>
                <td class="centertext ft10 ">{{item.cursoTitulo}}</td>
                <td class="centertext ft10 ">{{item.cursoPrecioOriginal}}</td>
                <td class="centertext ft10 ">{{item.cursoPorcentajeDescuento}}</td>
                <td class="centertext ft10 border-r">{{item.cursoPrecioFinal}}</td>
                <td class="centertext ft10 ">{{item.transaccionMoneda}}</td>
                <td class="centertext ft10 ">{{item.transaccionTax}}</td>
                <td class="centertext ft10 ">{{item.transaccionComisionCobro}}</td>
                <td class="centertext ft10 ">
                    {{item.transaccionFecha.toDate() | date }}
                </td>
                <td class="centertext ft10 ">
                    <div *ngIf="item.transaccionEstatusCobro==='paid'" class="sqChip backGreen5 ft11">
                        {{item.transaccionEstatusCobro}}
                    </div>
                    <div *ngIf="item.transaccionEstatusCobro==='unpaid'" class="sqChip backGray5 ft11">
                        {{item.transaccionEstatusCobro}}
                    </div>
                    <div *ngIf="item.transaccionEstatusCobro==='canceled'" class="sqChip backRed5 ft11">
                        {{item.transaccionEstatusCobro}}
                    </div>
                    <div *ngIf="item.transaccionEstatusCobro==='refunded'" class="sqChip backBlue5 ft11">
                        {{item.transaccionEstatusCobro}}
                    </div>
                </td>
                <td class="centertext ft10 ">
                    <div *ngIf="item.transaccionViaCobro==='stripe'" class="sqChip backPurple5 ft11">
                        {{item.transaccionViaCobro}}
                    </div>
                    <div *ngIf="item.transaccionViaCobro !='stripe'" class="sqChip backYellow5 ft11">
                        {{item.transaccionViaCobro}}
                    </div>
                </td>
                <td class="centertext ft10 border-r">
                    <mat-icon class="ft18" routerLink="/est/detalle-factura/{{item.transaccionId}}/{{item.usuarioId}}">download</mat-icon>
                {{item.usuarioId}}
                </td>


                <td class="centertext ft10 border-r">{{item.transaccionId}}</td>
                <td class="centertext ft10 ">{{item.instructorId}}</td>
                <td class="centertext blueLink ft500 ft10 " routerLink="/admin/ventas/{{item.instructorId}}">
                    {{item.instructorNombre}}</td>
                <td class="centertext ft10 ">{{item.instructorPorcentaje}}</td>
                <td class="centertext ft10 ">{{item.instructorTotal}}</td>
                <td class="centertext ft10 ">
                    <div *ngIf="item.instructorEstatusPago==='pagado'" class="sqChip backGreen5 ft11">
                        {{item.instructorEstatusPago}}
                    </div>
                    <div *ngIf="item.instructorEstatusPago==='pendiente'" class="sqChip backRed5 ft11">
                        {{item.instructorEstatusPago}}
                    </div>
                    <div *ngIf="item.instructorEstatusPago==='en proceso'" class="sqChip backOrange3 ft11">
                        {{item.instructorEstatusPago}}
                    </div>
                </td>
                <td class="centertext ft10 ">
                    <span *ngIf="item.instructorFechaPago" class="ft10">{{item.instructorFechaPago.toDate() | date }}</span></td>
                <td class="centertext ft10 ">{{item.instructorViaPago}}</td>
                <td class="centertext ft10  blueLink ft500" routerLink="/admin/detalle-pago/{{item.pagoId}}">
                    {{item.pagoId}}</td>
                <td *ngIf="id" class="centertext ft10 border-r" (click)="doNothing()">
                    <input *ngIf="item.pagoId===''" type="checkbox" (change)="checkMarcada(i, $event)">
                </td>
            </tr>

        </table>
    </div>

</div>